
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/feature/Footer';

export default function SitesAgente() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    document.title = 'Site Profissional Pronto em 10 Dias | 7deOuros';
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header específico para Sites + Agente */}
      <header className="shadow-sm sticky top-0 z-50" style={{ backgroundColor: '#f9f9f9' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center space-x-2">
              <img 
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/aa1326c90d527ffd18ec2db85b0a721b.png" 
                alt="7deOuros" 
                className="h-20 w-auto sm:h-24"
              />
            </Link>
            
            <nav className="hidden lg:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('o-que-recebe')}
                className="font-medium text-gray-700 hover:text-red-600 transition-colors duration-200 cursor-pointer"
              >
                O que você recebe
              </button>
              <button
                onClick={() => scrollToSection('prova-social')}
                className="font-medium text-gray-700 hover:text-red-600 transition-colors duration-200 cursor-pointer"
              >
                Depoimentos
              </button>
              <button
                onClick={() => scrollToSection('demos')}
                className="font-medium text-gray-700 hover:text-red-600 transition-colors duration-200 cursor-pointer"
              >
                Demos
              </button>
              <button
                onClick={() => scrollToSection('diferenciais')}
                className="font-medium text-gray-700 hover:text-red-600 transition-colors duration-200 cursor-pointer"
              >
                Diferenciais
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="font-medium text-gray-700 hover:text-red-600 transition-colors duration-200 cursor-pointer"
              >
                FAQ
              </button>
              <a
                href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20meu%20site%20agora.%20Quando%20podemos%20conversar%3F"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-lg"
              >
                Quero meu site
              </a>
            </nav>
            
            <button
              className="lg:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
          
          {isMenuOpen && (
            <div className="lg:hidden border-t border-gray-200 py-4">
              <div className="flex flex-col space-y-3">
                <button
                  onClick={() => scrollToSection('o-que-recebe')}
                  className="font-medium py-2 text-left text-gray-700 hover:text-red-600 transition-colors duration-200"
                >
                  O que você recebe
                </button>
                <button
                  onClick={() => scrollToSection('prova-social')}
                  className="font-medium py-2 text-left text-gray-700 hover:text-red-600 transition-colors duration-200"
                >
                  Depoimentos
                </button>
                <button
                  onClick={() => scrollToSection('demos')}
                  className="font-medium py-2 text-left text-gray-700 hover:text-red-600 transition-colors duration-200"
                >
                  Demos
                </button>
                <button
                  onClick={() => scrollToSection('diferenciais')}
                  className="font-medium py-2 text-left text-gray-700 hover:text-red-600 transition-colors duration-200"
                >
                  Diferenciais
                </button>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="font-medium py-2 text-left text-gray-700 hover:text-red-600 transition-colors duration-200"
                >
                  FAQ
                </button>
                <div className="pt-2">
                  <a
                    href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20meu%20site%20agora.%20Quando%20podemos%20conversar%3F"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl px-4 py-2 text-sm rounded-lg w-full"
                  >
                    Quero meu site
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Fixed Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-orange-500 p-4 lg:hidden">
        <a
          href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20meu%20site%20agora.%20Quando%20podemos%20conversar%3F"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-center bg-white text-orange-600 font-bold py-3 rounded-lg shadow-lg"
        >
          Quero meu site agora
        </a>
      </div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-20 lg:py-32 overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Sora, sans-serif' }}>
              Seu site profissional pronto<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-300">
                em até 10 dias
              </span><br />
              para atrair novos clientes
            </h1>
            
            <p className="text-xl lg:text-2xl text-blue-100 mb-12 leading-relaxed max-w-4xl mx-auto">
              Se sua presença online não convence, você perde clientes. Criamos sites modernos, rápidos e feitos para gerar confiança e resultados.
            </p>

            {/* Visual Dashboard */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-12 max-w-4xl mx-auto border border-white/20">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-search-line text-2xl text-white"></i>
                  </div>
                  <h3 className="font-semibold text-white mb-1">Diagnóstico</h3>
                  <p className="text-blue-200 text-sm">Análise do seu negócio</p>
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-window-line text-2xl text-white"></i>
                  </div>
                  <h3 className="font-semibold text-white mb-1">Página</h3>
                  <p className="text-blue-200 text-sm">Site profissional criado</p>
                </div>
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-3">
                    <i className="ri-whatsapp-line text-2xl text-white"></i>
                  </div>
                  <h3 className="font-semibold text-white mb-1">WhatsApp</h3>
                  <p className="text-blue-200 text-sm">Clientes chegam até você</p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="relative inline-block mb-8">
              <div className="absolute -inset-1 bg-gradient-to-r from-orange-400 to-orange-600 rounded-xl blur opacity-75 animate-pulse"></div>
              <a
                href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20meu%20site%20agora.%20Quando%20podemos%20conversar%3F"
                target="_blank"
                rel="noopener noreferrer"
                className="relative inline-flex items-center justify-center font-bold text-xl bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-12 py-6 rounded-xl shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-orange-500/25"
              >
                <i className="ri-rocket-line mr-3 text-2xl"></i>
                Quero meu site agora
              </a>
            </div>

            {/* Micro-prova */}
            <div className="flex flex-wrap justify-center items-center space-x-8 text-blue-200 text-sm">
              <div className="flex items-center">
                <i className="ri-shield-check-line mr-2 text-green-400"></i>
                Entrega garantida
              </div>
              <div className="flex items-center">
                <i className="ri-customer-service-line mr-2 text-orange-400"></i>
                Suporte 60 dias
              </div>
              <div className="flex items-center">
                <i className="ri-check-double-line mr-2 text-blue-400"></i>
                Sem compromisso
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg className="w-full h-16" viewBox="0 0 1440 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 64H1440V24C1440 24 1200 0 720 0C240 0 0 24 0 24V64Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* O preço de parecer pequeno */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              O preço de parecer pequeno
            </h2>
            <p className="text-xl text-gray-600">
              Cada dia sem site profissional custa caro.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Só Instagram/Linktree */}
            <div className="bg-red-50 rounded-2xl p-8 border border-red-200">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-instagram-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Só Instagram/Linktree</h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <p className="text-gray-700">Sem site = sem autoridade, sem confiança</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <p className="text-gray-700">Invisível no Google → clientes encontram o concorrente</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <p className="text-gray-700">Links confusos → ninguém entende, ninguém compra</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <p className="text-gray-700">Link na bio sem destino claro não converte</p>
                </div>
              </div>
            </div>

            {/* Site obsoleto */}
            <div className="bg-orange-50 rounded-2xl p-8 border border-orange-200">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-computer-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Site obsoleto</h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-orange-500 mt-1"></i>
                  <p className="text-gray-700">Layout antigo transmite desconfiança</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-orange-500 mt-1"></i>
                  <p className="text-gray-700">Carregamento lento → cliente fecha a aba</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-orange-500 mt-1"></i>
                  <p className="text-gray-700">Não funciona no celular → 70% acessam pelo celular</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-line text-orange-500 mt-1"></i>
                  <p className="text-gray-700">Pior que não ter: você é achado, mas descartado</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Pare%20de%20perder%20clientes%20-%20quero%20meu%20site%20agora.%20Quando%20podemos%20conversar%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center font-bold text-xl bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-10 py-5 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <i className="ri-stop-circle-line mr-3"></i>
              Pare de perder clientes — quero meu site agora
            </a>
          </div>
        </div>
      </section>

      {/* O que dizem as pesquisas */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              O que dizem as pesquisas
            </h2>
            <p className="text-xl text-gray-600">
              Dados oficiais que comprovam: sem presença profissional online, você perde clientes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Card Google */}
            <a
              href="https://business.google.com/br/think/future-of-marketing/transformacao-comportamento-cultura-negocios/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-google-line text-2xl text-blue-600"></i>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-blue-600 mb-4">68%</div>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  dos brasileiros compram de marcas desconhecidas SE acham online
                </p>
                <p className="text-sm text-gray-500 font-medium mb-3">Google Think - 2025</p>
                <div className="flex items-center justify-center text-blue-600 text-sm group-hover:text-blue-700">
                  <i className="ri-external-link-line mr-1"></i>
                  <span>Ver pesquisa completa</span>
                </div>
              </div>
            </a>

            {/* Card PWC */}
            <a
              href="https://www.pwc.com.br/pt/sala-de-imprensa/release/consumidor-inicia-escolha-por-produto-muito-antes-da-hora-da-compra.html"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-bar-chart-line text-2xl text-orange-600"></i>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-orange-600 mb-4">79%</div>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  dos consumidores pesquisam online antes da decisão final de compra
                </p>
                <p className="text-sm text-gray-500 font-medium mb-3">PWC Global Consumer Survey - 2023</p>
                <div className="flex items-center justify-center text-orange-600 text-sm group-hover:text-orange-700">
                  <i className="ri-external-link-line mr-1"></i>
                  <span>Ver pesquisa completa</span>
                </div>
              </div>
            </a>

            {/* Card Reclame Aqui */}
            <a
              href="https://portal.clientesa.com.br/quase-100-dos-consumidores-leem-avaliacoes-no-google-antes-de-escolher-uma-loja/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-star-line text-2xl text-green-600"></i>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-green-600 mb-4">96%</div>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  leem avaliações no Google antes de escolher uma empresa local
                </p>
                <p className="text-sm text-gray-500 font-medium mb-3">Reclame Aqui + Harmo - 2025</p>
                <div className="flex items-center justify-center text-green-600 text-sm group-hover:text-green-700">
                  <i className="ri-external-link-line mr-1"></i>
                  <span>Ver pesquisa completa</span>
                </div>
              </div>
            </a>
          </div>

          {/* Frase de impacto */}
          <div className="text-center mb-8">
            <p className="text-2xl lg:text-3xl font-bold text-gray-900 mb-8">
              Resumindo: sem site profissional, você perde 7 de cada 10 oportunidades de negócio
            </p>
          </div>

          {/* CTA da seção */}
          <div className="text-center">
            <a
              href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20minha%20presen%C3%A7a%20profissional%20online.%20Quando%20podemos%20conversar%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center font-bold text-xl bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-10 py-5 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <i className="ri-line-chart-line mr-3"></i>
              Quero minha presença profissional online
            </a>
          </div>
        </div>
      </section>

      {/* O que você recebe */}
      <section id="o-que-recebe" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              O que você recebe
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-window-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">Página profissional que inspira credibilidade</h3>
              <p className="text-gray-600 text-center">Design moderno e responsivo que converte no celular</p>
            </div>

            <div className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-robot-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">Atendimento com IA 24h</h3>
              <p className="text-gray-600 text-center">Conversa e responde dúvidas frequentes automaticamente</p>
            </div>

            <div className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">WhatsApp integrado</h3>
              <p className="text-gray-600 text-center">Clientes chegam direto no seu WhatsApp</p>
            </div>

            <div className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-list-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">Formulário inteligente</h3>
              <p className="text-gray-600 text-center">Para captar clientes reais interessados</p>
            </div>

            <div className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">Domínio e e-mail profissional</h3>
              <p className="text-gray-600 text-center">suaempresa.com.br + contato@suaempresa.com.br</p>
            </div>

            <div className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-line text-2xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">Suporte técnico por 60 dias</h3>
              <p className="text-gray-600 text-center">Ajuda completa para você usar tudo</p>
            </div>
          </div>

          <div className="text-center">
            <a
              href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20meu%20site%20profissional%20agora.%20Quando%20podemos%20conversar%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center font-bold text-xl bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-10 py-5 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <i className="ri-rocket-line mr-3"></i>
              Quero meu site profissional agora
            </a>
          </div>
        </div>
      </section>

      {/* Por que confiar na 7deOuros */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Por que confiar na 7deOuros?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Bloco 1 - Mais de 300 empresas */}
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <span className="text-blue-600 font-black">Mais de 300 empresas</span><br />
                já transformadas
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed">
                Centenas de empresários já transformaram seus resultados através de nossa experiência em estratégia de negócios, agora aplicada ao mundo digital.
              </p>
            </div>

            {/* Bloco 2 - Experiência em multinacionais */}
            <div className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <span className="text-orange-600 font-black">Experiência em multinacionais</span><br />
                e estratégia de negócios
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed">
                Nossa expertise vem de anos trabalhando com grandes empresas, aplicando estratégias que realmente funcionam.
              </p>
            </div>

            {/* Bloco 3 - Do crescimento offline ao digital */}
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-6 mb-6">
                <i className="ri-arrow-right-up-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <span className="text-green-600 font-black">Do crescimento offline</span><br />
                ao digital
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed">
                Conectamos nossa trajetória de sucesso no mundo físico com soluções digitais que geram resultados reais.
              </p>
            </div>
          </div>

          {/* Frase de impacto */}
          <div className="text-center bg-gradient-to-r from-blue-50 to-orange-50 rounded-2xl p-8">
            <p className="text-2xl lg:text-3xl font-bold text-gray-900 leading-relaxed">
              👉 "Você não ganha só um site. Ganha uma presença online feita por quem já ajudou centenas de empresários a vender mais."
            </p>
          </div>
        </div>
      </section>

      {/* Prova social - Depoimentos */}
      <section id="prova-social" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Negócios que já confiam na gente
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Depoimento 1 */}
            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">Dr. Carlos Mendes</h3>
                  <p className="text-blue-600 font-semibold">Clínica Odontológica</p>
                </div>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                "Em 15 dias já estava recebendo 40% mais contatos pelo WhatsApp. A IA responde as dúvidas básicas e eu só atendo quem realmente quer agendar."
              </p>
              <div className="flex items-center text-sm text-gray-600">
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-2"></i>
                <span>Resultado em 15 dias</span>
              </div>
            </div>

            {/* Depoimento 2 */}
            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-pink-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">Marina Silva</h3>
                  <p className="text-pink-600 font-semibold">Estúdio de Beleza</p>
                </div>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                "Antes só tinha Instagram. Agora tenho um site que passa confiança e a IA funciona 24h. Minhas clientes adoram a praticidade."
              </p>
              <div className="flex items-center text-sm text-gray-600">
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-2"></i>
                <span>Resultado em 8 dias</span>
              </div>
            </div>

            {/* Depoimento 3 */}
            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">Roberto Santos</h3>
                  <p className="text-green-600 font-semibold">Escritório de Advocacia</p>
                </div>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                "O site transmite a seriedade que meu escritório precisa. A IA qualifica os clientes e só chegam casos reais no meu WhatsApp."
              </p>
              <div className="flex items-center text-sm text-gray-600">
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-1"></i>
                <i className="ri-star-fill text-yellow-500 mr-2"></i>
                <span>Resultado em 12 dias</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Demos */}
      <section id="demos" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Veja o padrão por nicho
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {[
              {
                setor: 'Estética',
                cor: 'pink',
                icon: 'ri-heart-line',
                image:
                  'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/b5b016f882d770817b6700549b5f68b7.png',
                url: 'https://ourosestetica.shop/',
              },
              {
                setor: 'Advocacia',
                cor: 'blue',
                icon: 'ri-scales-line',
                image:
                  'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/0fd4ec7f9253d7be985271ab52dc3838.png',
                url: 'https://ourosadvocacia.shop/',
              },
              {
                setor: 'Odonto',
                cor: 'green',
                icon: 'ri-tooth-line',
                image:
                  'https://readdy.ai/api/search-image?query=Modern%20dental%20clinic%20website%20homepage%20showcasing%20dental%20treatments%20and%20oral%20health%20services%2C%20clean%20green%20and%20white%20medical%20design%2C%20contemporary%20dental%20office%20with%20modern%20equipment%20and%20comfortable%20patient%20chairs%2C%20professional%20dentist%20examining%20patient%2C%20dental%20procedures%20and%20smile%20transformations%2C%20mobile-optimized%20for%20dental%20practice&width=400&height=300&seq=odonto-demo&orientation=landscape',
                url: 'https://ourosodontologia.shop/',
              },
              {
                setor: 'Engenharia',
                cor: 'yellow',
                icon: 'ri-building-line',
                image:
                  'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/9eefd8ff5fb070d2ba29db007cf02170.png',
                url: 'https://regianefialho.com.br/',
              },
              {
                setor: 'Contabilidade',
                cor: 'purple',
                icon: 'ri-calculator-line',
                image:
                  'https://readdy.ai/api/search-image?query=Modern%20accounting%20firm%20website%20homepage%20showing%20financial%20services%20and%20tax%20consultation%2C%20professional%20purple%20and%20white%20business%20design%2C%20contemporary%20office%20with%20accountants%20working%20on%20computers%20and%20financial%20documents%2C%20calculator%20and%20financial%20charts%2C%20business%20meeting%20discussing%20financial%20planning%2C%20mobile-responsive%20for%20accounting%20practice&width=400&height=300&seq=contabilidade-demo&orientation=landscape',
                url: 'https://ouroscontabilidade.shop/',
              },
              {
                setor: 'Climatização',
                cor: 'cyan',
                icon: 'ri-temp-cold-line',
                image:
                  'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/c7a0ef407a75b1a4468b09369f816b51.png',
                url: 'https://ourosclimatizacao.shop/',
              },
            ].map((demo, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 hover:shadow-lg transition-shadow">
                <div className="h-48 rounded-lg overflow-hidden mb-4">
                  <img src={demo.image} alt={`Demo ${demo.setor}`} className="w-full h-full object-cover" />
                </div>
                <div className="flex items-center justify-center mb-3">
                  <div className={`w-8 h-8 bg-${demo.cor}-100 rounded-full flex items-center justify-center mr-2`}>
                    <i className={`${demo.icon} text-sm text-${demo.cor}-600`}></i>
                  </div>
                  <span className="text-gray-900 font-semibold">{demo.setor}</span>
                </div>
                <p className="text-gray-600 text-sm text-center mb-4">Site otimizado para conversão</p>
                <a
                  href={demo.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors cursor-pointer"
                >
                  Ver Demo
                </a>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20meu%20site%20agora.%20Quando%20podemos%20conversar%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center font-bold text-xl bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-10 py-5 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              <i className="ri-rocket-line mr-3"></i>
              Quero meu site agora
            </a>
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section id="diferenciais" className="py-20 bg-gray-900 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              O que nos torna diferentes
            </h2>
          </div>

          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-trophy-line text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">+300 empresas atendidas, com aumento médio de 30% no faturamento</h3>
                <p className="text-gray-300">Experiência comprovada em resultados reais</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-timer-line text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">Site no ar em até 10 dias</h3>
                <p className="text-gray-300">Entrega rápida sem perder qualidade</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-whatsapp-line text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">Páginas feitas para conversão (WhatsApp first)</h3>
                <p className="text-gray-300">Cada elemento pensado para gerar contatos</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-robot-line text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">IA integrada para suporte 24/7</h3>
                <p className="text-gray-300">Atendimento automático que nunca para</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-smartphone-line text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">Design moderno, rápido e responsivo</h3>
                <p className="text-gray-300">Funciona perfeitamente em todos os dispositivos</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Garantia */}
      <section className="py-20 bg-green-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-3xl p-12 shadow-lg">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-8">
              <i className="ri-shield-check-line text-3xl text-green-600"></i>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Sem risco para você
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Se a primeira versão não representar sua marca como prometido, ajustamos dentro das revisões previstas até ficar certo. Nosso compromisso é com o seu sucesso.
            </p>
          </div>
        </div>
      </section>

      {/* Fechamento */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-6xl font-bold mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
            Comece hoje e tenha um site que gera clientes já na próxima semana
          </h2>
          <p className="text-xl lg:text-2xl text-gray-300 mb-12 leading-relaxed">
            Sua presença online profissional pode estar pronta em poucos dias.
          </p>

          <a
            href="https://wa.me/5544988047699?text=Ol%C3%A1%21%20Quero%20solicitar%20meu%20site%20agora.%20Vamos%20come%C3%A7ar%20hoje%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center font-bold text-2xl bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-12 py-6 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            <i className="ri-send-plane-line mr-3"></i>
            Solicitar meu site agora
          </a>

          <div className="mt-8 text-sm text-gray-400 space-x-6">
            <span>✓ Sem taxa de setup</span>
            <span>✓ Domínio incluído</span>
            <span>✓ SSL gratuito</span>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Perguntas Frequentes
            </h2>
          </div>

          <div className="space-y-8">
            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Em quanto tempo meu site fica pronto?</h3>
              <p className="text-gray-600">Em até 10 dias úteis, já no ar e funcionando.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Já tenho domínio, posso usar?</h3>
              <p className="text-gray-600">Sim. Configuramos o seu ou registramos um novo.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Meu site vai aparecer no Google?</h3>
              <p className="text-gray-600">Entregamos SEO on-page básico e estrutura pronta para indexação.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Preciso saber mexer em tecnologia?</h3>
              <p className="text-gray-600">Não. Nós cuidamos de tudo para você.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Como funciona o agente de IA?</h3>
              <p className="text-gray-600">Ele responde dúvidas 24h, encaminhando para seu WhatsApp.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Vocês atendem meu nicho?</h3>
              <p className="text-gray-600">Sim. Temos padrão por nicho e adaptamos ao seu posicionamento.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">O que é considerado "novo escopo"?</h3>
              <p className="text-gray-600">Novas seções, integrações extras ou mudança de direção no layout.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Posso pedir mudanças depois de publicado?</h3>
              <p className="text-gray-600">Sim. Está incluído suporte por 60 dias; evoluções maiores são tratadas como adicionais.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Podem criar meus textos e imagens?</h3>
              <p className="text-gray-600">Sim. Fornecemos copy de conversão e imagens de banco; materiais próprios são bem-vindos.</p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Integram com ferramentas que já uso?</h3>
              <p className="text-gray-600">WhatsApp, Google Maps já inclusos. Outras integrações podem ser orçadas.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
